import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { INPUT_TRACKING_TYPES, inputOnChange } from '../../../lib/utils';
import type { MonthlyPaymentInputProps } from '../types';
import {
  getFieldPlaceholderByCalculator,
  getFieldValueByCalculator,
} from '../utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const PropertyTaxesInput = (props: MonthlyPaymentInputProps): JSX.Element => {
  const {
    placeholder,
    value,
    error,
    errorMessage,
    calculator,
    dispatch,
    analytics,
    label = 'Property taxes',
    tooltip = 'The tax that you pay as a property owner, levied by the city, county or municipality.',
    fullWidth = true,
  } = props;

  const analyticsEnabled = analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'propertyTax',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      overridesValue: 'monthlyPayments',
      overrides: true,
      legacy,
      bedrock,
      fieldName: 'propertyTax',
      calculator,
      inputType: 'currency',
    });
  };

  const placeholderValue = _.isNil(placeholder)
    ? ''
    : num.formatCurrency(placeholder);
  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  return (
    <InputMoney
      label={label}
      tooltip={tooltip}
      placeholder={placeholderValue}
      value={currencyValue}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  const errorMessage = state?.validations?.propertyTax?.[0];
  const error = !!errorMessage;

  return {
    error,
    errorMessage,
    value: getFieldValueByCalculator(state, calculator, 'propertyTaxes'),
    placeholder: String(
      getFieldPlaceholderByCalculator(state, calculator, 'propertyTaxes')
    ),
  };
};

export default connect(mapStateToProps)(PropertyTaxesInput);
